import { DEFAULT_LOCALE, isLocale } from './config';
import { createT, type Namespace } from './messages';

/**
 * React 훅을 쓸 수 없는 클라이언트 코드(토스트를 띄우는 가드 함수 등)용 번역 함수.
 * 서버가 `<html lang>` 에 요청 언어를 실어 두므로 그 값을 읽는다. 서버에서 불리면 기본 언어.
 */
export function browserT(ns: Namespace) {
  const lang =
    typeof document !== 'undefined' ? document.documentElement.lang : '';
  return createT(isLocale(lang) ? lang : DEFAULT_LOCALE, ns);
}
